import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LangChangeEvent, TranslateService, TranslationChangeEvent } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { ConversaoLibraConverte } from '../../../../shared/conversao-libra/conversao-libra-converte';
import { ListItem } from '../../../../shared/dropdown-list/ListItem';
import { ListitemBuilder } from '../../../../shared/dropdown-list/ListItemBuilder';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { IColunaGrid } from '../../../../shared/gridview/estrutura/IColunaGrid';
import { EstruturaGridViewBuilder } from '../../../../shared/gridview/EstruturaGridViewBuilder';
import { PrintPdfService } from '../../../../shared/print-pdf/print-pdf.service';
import { OsService } from '../os-service/os.service';
import { RmpvDetalhadoService } from '../../rmpv-detalhado/rmpv-detalhado.service';
import { RetornoSelecao } from '../../../../shared/gridview/RetornoSelecao';

@Component({
  selector: 'app-os',
  templateUrl: './os.component.html',
  styleUrls: ['./os.component.css']
})
export class OsComponent implements OnInit, OnChanges {

  carregando = true;
  model: any = {};
  notas: any[] = [];
  _id: string;
  nomeModulo: string;
  tituloTabela: string;
  reclamacao = true; // flag q mostra uma mensagem quando não há dados a ser exibido em peças os
  execucao = true; // flag q mostra uma mensagem quando não há dados a ser exibido em execucao os

  total_bruto_servicos = 0;
  desconto_servicos = 0;
  total_liquido_servicos = 0;

  total_bruto_produtos = 0;
  desconto_produtos = 0;
  total_liquido_produtos = 0;

  total_bruto = 0;
  total_desconto = 0;
  total_liquido = 0;

  categorias: ListItem[];
  estruturaExecucao: IColunaGrid[];
  estruturaNotas: IColunaGrid[];
  estruturaPecas: IColunaGrid[];

  dadosTranslate = [];
  dados: any;
  botao: boolean;
  subscription;

  idDealer: number;
  numeroOsValue:number;
  isFab: boolean;
  idMarca: number;
  /** Marca GWM conforme filtro / dash_filtro_marcas */
  isMarcaGwm = false;
  /** HAVAL / GWM / etc. pelos dados do veículo quando o filtro não identifica a marca */
  isMarcaGwmVeiculo = false;

  private marcasDash: any[] = [];

  @Input() temAcompanhamento = false;
  /** Id da marca selecionada no RMPV detalhado (filtro da lista). Sem isso, a 1ª marca do dash era usada por engano. */
  @Input() idMarcaFiltro: number | string | null = null;


  translateDadosGrid = {
    "REVISAO": "rmpv.detalhado.detalhadoOS.servicos.revisao"
  }

  constructor(
    private service: OsService,
    private route: ActivatedRoute,
    private filtro: FiltroService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef,
    private printPdf: PrintPdfService,
    private conversaoLibraConverte: ConversaoLibraConverte,
    private serviceExport: RmpvDetalhadoService) {

    this.nomeModulo = 'detalhado';
    this.getTranslate();
  }

  ngOnInit() {
    this.getMarcas();
    this.botao = true;
    this.carregarVazio();

    //conversaolibra
    this.conversaoLibraConverte.preencher();
    this.subscription = this.translate.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.buscarOs(this.id);
        this.carregarCategorias();
      });
    //fimConversaolibra
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idMarcaFiltro'] && this.marcasDash.length) {
      this.aplicarMarcaDoFiltro();
    }
  }

  /** Combina flag da lista, API de detalhe da O.S. e detecção GWM (filtro ou veículo). */
  get exibirFolhaAcompanhamento(): boolean {
    const tem = !!(this.temAcompanhamento || this.model?.temAcompanhamento);
    const gwm = this.isMarcaGwm || this.isMarcaGwmVeiculo;
    return tem && gwm;
  }

  @Input() set id(valor: string) {
    this._id = valor;
    this.buscarOs(this.id);
  }

  get id(): string {
    return this._id;
  }

  carregarVazio(): any {
    this.model.cliente = {};
    this.model.consultor = {};
    this.model.pagamento = {};
    this.model.veiculo = {};
    this.model.reclamacoes = [];
    const reclamacao: any = {};
    reclamacao.servicos = [];
    this.model.reclamacoes.push(reclamacao);

    this.criarGridExecucao();
    this.criarGridNotas();
    this.criarGridPecas();
  }

  private criarGridExecucao() {
    this.estruturaExecucao = new EstruturaGridViewBuilder()
      .addColuna('produtivo', 'rmpv.detalhado.detalhadoOS.execucao.execucaoGrid.produtivo')
      .addColuna('inicio', 'rmpv.detalhado.detalhadoOS.execucao.execucaoGrid.inicio')
      .addColuna('fim', 'rmpv.detalhado.detalhadoOS.execucao.execucaoGrid.fim')
      .addColuna('tempo', 'rmpv.detalhado.detalhadoOS.execucao.execucaoGrid.tempo')
      .build();
  }

  private criarGridNotas() {
    this.estruturaNotas = new EstruturaGridViewBuilder()
      .addColuna('tipo', 'rmpv.detalhado.detalhadoOS.notas.notasGrid.tipo')
      .addColuna('numero', 'rmpv.detalhado.detalhadoOS.notas.notasGrid.numero')
      .addColuna('serie', 'rmpv.detalhado.detalhadoOS.notas.notasGrid.serie')
      .addColuna('data', 'rmpv.detalhado.detalhadoOS.notas.notasGrid.data')
      .addColuna('status', 'rmpv.detalhado.detalhadoOS.notas.notasGrid.status')
      .build();
  }

  private criarGridPecas() {
    this.estruturaPecas = new EstruturaGridViewBuilder()
      .addColuna('codigo', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.codigo')
      .addColuna('descricao', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.descricao')
      .addColuna('quantidade', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.qtde')
      .addColuna('valorVenda', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.vlVenda')
      .addColuna('valorCusto', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.vlCusto')
      .addColuna('desconto', 'rmpv.detalhado.detalhadoOS.pecas.pecaGrid.desconto')
      .build();
  }

  private buscarOs(id) {
    if (id) {
      this.service.setUrl(id);

      this.service.get([])
        .then(res => {
          this.tratarDados(res);
          this.carregando = false;
        })
        .catch(error => {
          this.carregando = false;
          this.tratarErro(error);
        });
    }
  }

  private preencherDadosOs() {
  const os = this.model;

  this.numeroOsValue = os.numero;
  this.idDealer = os.dealer;
  this.isFab = os.idNumeroOs != null;
  return;
  }

  private tratarDados(res: any) {

    this.dados = res.dados[0];

    //------- Retorna se há peças na os ------------/  
    res.dados[0].reclamacoes.forEach(element => {
      element.servicos.forEach(element2 => {
        if (element2.requisicoes.length >= 1) {
          this.reclamacao = false;
        }
      });
    });

    //------- Retorna se há Execução de serviço na os ------------/  
    res.dados[0].reclamacoes.forEach(element3 => {
      element3.servicos.forEach(element4 => {
        if (element4.codigo) {
          this.execucao = false;
        }
      });
    });
    //---------------------------------------------/

    if (res.dados.length > 0) {
      this.model = res.dados[0];
      this.atualizarMarcaGwmPeloVeiculo();

      if (this.model.numeroOsFabrica != null && this.model.numeroOsFabrica !== undefined && this.model.numeroOsFabrica !== '') {
        this.model.idNumeroOs = this.model.numero;
        this.model.numero = this.model.numeroOsFabrica;
      } else {
        this.model.idNumeroOs = null;
      }
      
      this.carregarNotas();
      this.carregarCategorias();
    }
  }

  private tratarErro(error: any) {
    let mensagem: string;
    try {
      mensagem = `Erro carregando os dados da O.S. \n ${error.erro}`;
    } catch (Exception) {
      mensagem = 'Erro carregando os dados da O.S.';
    }
    this.toastr.error(mensagem, 'Erro', <any>error);
  }

  private carregarNotas() {
    this.notas = this.model.notasFiscais;
    this.notas.forEach(item => {
      item.data = item.data.substring(0, 10).split('-').reverse().join("/");
    });
  }

   private carregarExecucoes(execucoes: any[] = []): any[] {
     const lista: any[] = [];
    const formatDate = (value: any): string => {
      if (!value) return " - "; // null, undefined, "" -> traço

      // Se já for Date, transforma em string ISO
      if (value instanceof Date) {
        value = value.toISOString();
      }

      // forçar para string (protege números ou outros tipos)
      const str = String(value);

      // tenta extrair os 10 primeiros chars (yyyy-mm-dd) com segurança
      const part = str.length >= 10 ? str.slice(0, 10) : str;

      // se não estiver no formato esperado, retorna como veio (ou traço)
      if (!part.includes("-")) return part || " - ";

      return part.split("-").reverse().join("/");
  };

  (execucoes || []).forEach(item => {
    const a: any = {};
    a.produtivo = item?.produtivo?.nome ?? " - ";
    a.inicio = formatDate(item?.inicio);
    a.fim = formatDate(item?.fim);
    a.tempo = item?.tempo ?? 0; // ou " - " se preferir string

    lista.push(a);
  });

  return lista;
}

  private carregarPecas(pecas: any[]) {
    const lista: any[] = [];

    pecas.forEach(item => {
      const a: any = {};

      a.codigo = item.codigo;
      a.descricao = item.descricao;
      a.quantidade = item.quantidade;
      a.valorVenda = this.conversaoLibraConverte.conversaoLibra(item.valorVenda, null, null)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        .replace("R$", "");
      a.valorCusto = this.conversaoLibraConverte.conversaoLibra(item.valorCusto, null, null)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        .replace("R$", "");
      a.desconto = this.conversaoLibraConverte.conversaoLibra(item.valorDesconto, null, null)
        .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        .replace("R$", "");

      lista.push(a);
    })
    return lista;
  }

  private carregarCategorias() {
    this.total_bruto_servicos = this.conversaoLibraConverte.conversaoLibra(this.model.total_bruto_servicos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.desconto_servicos = this.conversaoLibraConverte.conversaoLibra(this.model.desconto_servicos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_liquido_servicos = this.conversaoLibraConverte.conversaoLibra(this.model.total_liquido_servicos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_bruto_produtos = this.conversaoLibraConverte.conversaoLibra(this.model.total_bruto_produtos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.desconto_produtos = this.conversaoLibraConverte.conversaoLibra(this.model.desconto_produtos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_liquido_produtos = this.conversaoLibraConverte.conversaoLibra(this.model.total_liquido_produtos, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_bruto = this.conversaoLibraConverte.conversaoLibra(this.model.total_bruto, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_desconto = this.conversaoLibraConverte.conversaoLibra(this.model.total_desconto, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");
    this.total_liquido = this.conversaoLibraConverte.conversaoLibra(this.model.total_liquido, null, null)
      .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      .replace("R$", "");

    this.categorias = [];

    if (this.model.categoria) {
      const builder = new ListitemBuilder();
      this.filtro.buscar('categoria_os')
        .then(res => {
          res.filtros.forEach(element => {
            builder.add(element.id, element.descricao);
          });

          this.categorias = builder.build();
        });
    }
  }

  getTranslate(value?) {
    this.translate.onLangChange
      .subscribe((event: TranslationChangeEvent) => {

        let caminhoDetalhadoOS = event.translations.rmpv.detalhado.detalhadoOS;
        this.dadosTranslate.push(caminhoDetalhadoOS);

        this.dadosTranslate.forEach(item => {
          let statusCpf = item.dadosPrincipais.consultor.cpfStatus;

          if (this.dados.consultor.cpf === statusCpf.ativo || this.dados.status === 'CANCELADA') {
            if (event.lang === 'br') {
              this.dados.consultor.cpf = statusCpf.ativo;
              this.dados.status = 'CANCELADA';
            } else {
              this.dados.consultor.cpf = statusCpf.ativo;
              this.dados.status = 'CANCELED';
            }
          }

          if (this.dados.consultor.cpf === statusCpf.inativo || this.dados.status === 'FECHADA') {
            if (event.lang === 'br') {
              this.dados.consultor.cpf = statusCpf.inativo;
              this.dados.status = 'FECHADA';
            } else {
              this.dados.consultor.cpf = statusCpf.inativo;
              this.dados.status = 'CLOSED';
            }
          }
        });
      });
    return this.translateDadosGrid[value];
  }

  imprimePdf() {
    this.botao = false;
    document.getElementById("dados-principais").classList.remove("tab-pane");
    document.getElementById("dados-principais").classList.remove("fade");
    document.getElementById("servicos").classList.remove("tab-pane");
    document.getElementById("servicos").classList.remove("fade");
    document.getElementById("pecas").classList.remove("tab-pane");
    document.getElementById("pecas").classList.remove("fade");
    document.getElementById("execucao").classList.remove("tab-pane");
    document.getElementById("execucao").classList.remove("fade");
    document.getElementById("notas").classList.remove("tab-pane");
    document.getElementById("notas").classList.remove("fade");

    if (this.translate.currentLang == 'br') {
      this.tituloTabela = 'ORDEM DE SERVIÇO';
    } else if (this.translate.currentLang == 'gb') {
      this.tituloTabela = 'SERVICE ORDER';
    }

    this.printPdf.nomeModulo = this.nomeModulo;
    this.printPdf.tituloTabela = this.tituloTabela;
    this.printPdf.exportPDFA4SemData();

    document.getElementById("dados-principais").classList.add("tab-pane");
    document.getElementById("dados-principais").classList.add("fade");
    document.getElementById("servicos").classList.add("tab-pane");
    document.getElementById("servicos").classList.add("fade");
    document.getElementById("pecas").classList.add("tab-pane");
    document.getElementById("pecas").classList.add("fade");
    document.getElementById("execucao").classList.add("tab-pane");
    document.getElementById("execucao").classList.add("fade");
    document.getElementById("notas").classList.add("tab-pane");
    document.getElementById("notas").classList.add("fade");

    this.toastr.info('Aguarde a Impressão...', 'Informação', {
      timeOut: 10000
    });

    setTimeout(() => {
      this.botao = true;
    }, 5000);
  }

  protected formatDate(pData) {
    return pData.substring(0, 10);
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  exportarPDF() {
    this.serviceExport.exportPDF(this.id).subscribe((base64String: string) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
      const a = document.createElement('a');
      a.href = fileURL;
      // a.target = '_blank';
      a.download = `OrdemServico.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

  imprimirFolhaAcompanhamento() {
    this.preencherDadosOs();
    this.serviceExport.exportAcompanhamento(this.numeroOsValue, this.idDealer, this.isFab).subscribe((base64String: string) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = `FolhaAcompanhamento.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

   exportPDFMontadora() {
    this.preencherDadosOs();
    this.serviceExport.exportPDFosMontadora(this.numeroOsValue, this.idDealer, this.isFab).subscribe((base64String: string) => {
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL);
      const a = document.createElement('a');
      a.href = fileURL;
      // a.target = '_blank';
      a.download = `OrdemServicoMontadora.pdf`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

  private atualizarMarcaGwmPeloVeiculo(): void {
    const v = this.model?.veiculo;
    if (!v) {
      this.isMarcaGwmVeiculo = false;
      return;
    }
    const texto = `${v.produto || ''} ${v.modelo || ''}`.toUpperCase();
    this.isMarcaGwmVeiculo =
      texto.includes('HAVAL') ||
      texto.includes('GWM') ||
      texto.includes('WEY') ||
      texto.includes('TANK');
  }

  private aplicarMarcaDoFiltro(): void {
    const lista = this.marcasDash;
    if (!lista.length) {
      return;
    }
    const id = this.idMarcaFiltro;
    if (id != null && id !== '') {
      const marca = lista.find(m => m.id == id || String(m.id) === String(id));
      const m = marca || lista[0];
      this.idMarca = m?.id;
      this.isMarcaGwm = (m?.descricao || '').toUpperCase().includes('GWM');
    } else {
      this.idMarca = lista[0]?.id;
      this.isMarcaGwm = false;
    }
  }

  getMarcas() {
    this.serviceExport.getFiltroMarcas().subscribe({
      next: (res) => {
        this.marcasDash = res.dados || [];
        this.aplicarMarcaDoFiltro();
      },
      error: (err) => {
        console.error(err);
      }
    });
  }


  


  
}
